"use strict";
// Copyright (C) 2017-2024 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var common_1 = require("stremio/common");
var useCalendar = function (urlParams) {
    var action = react_1.default.useMemo(function () {
        var args = urlParams.year && urlParams.month ? {
            year: parseInt(urlParams.year),
            month: parseInt(urlParams.month),
            day: urlParams.day ? parseInt(urlParams.day) : null,
        } : null;
        return {
            action: 'Load',
            args: {
                model: 'Calendar',
                args: args,
            },
        };
    }, [urlParams]);
    var calendar = (0, common_1.useModelState)({ model: 'calendar', action: action });
    return calendar;
};
exports.default = useCalendar;
